









import { defineComponent } from '@nuxtjs/composition-api';
import SfAccordionItem from './SfAccordionItem.vue';

export default defineComponent({
  name: 'SfAccordion',
  components: {
    SfAccordionItem,
  },
  props: {
    open: {
      type: [String, Array],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
      default: '',
    },
    showChevron: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      items: [],
      openHeader: this.open,
      internalMultiple: this.multiple,
    };
  },
  computed: {
    headersAreClosed(): any {
      return this.$children
        .map((header: any) => header.isOpen)
        .every((header) => header === false);
    },
  },
  watch: {
    open(newValue, oldValue) {
      if (!newValue || newValue === oldValue) return;
      const activeHeader: any = this.$children.find(
        (accordionItem: any) => accordionItem.header === newValue,
      );
      // eslint-disable-next-line no-underscore-dangle
      this.toggleHandler(activeHeader._uid);
    },
  },
  mounted() {
    this.$on('toggle', this.toggleHandler);
    this.setAccordionItems();
    this.setAsOpen();
    this.$emit('click:open-header');
  },
  updated() {
    this.setAccordionItems();
    this.setAsOpen();
    this.$emit('click:open-header');
  },
  methods: {
    setAccordionItems() {
      if (this.$children && this.$children.length > 0) {
        this.items = this.$children;
      }
    },
    setAsOpen() {
      if (this.$children && this.$children.length > 0) {
        if (this.open === 'all') {
          this.internalMultiple = true;
          this.openHeader = this.items.map((child) => child.header);
        }
        this.items.forEach((child) => {
          child.isOpen = Array.isArray(this.openHeader)
            ? this.openHeader.includes(child.header)
            : this.openHeader === child.header;
        });
      }
    },
    toggleHandler(slotId) {
      if (!this.internalMultiple && !Array.isArray(this.openHeader)) {
        this.items.forEach((child) => {
          if (child._uid === slotId) {
            child.isOpen = !child.isOpen;
            this.openHeader = child.header;
            this.$emit('click:open', this.openHeader);
          } else {
            child.isOpen = false;
          }
        });
      } else {
        const clickedHeader = this.items.find((child) => child._uid === slotId);
        clickedHeader.isOpen = !clickedHeader.isOpen;
        this.openHeader = this.items.reduce(
          (openHeaders, item) => (item.isOpen ? [...openHeaders, item.header] : openHeaders),
          [],
        );
        this.$emit('click:open', clickedHeader.isOpen);
      }
      if (this.headersAreClosed) {
        this.openHeader = '';
      }
    },
  },
});
